import { render, staticRenderFns } from "./SuggestedStudentForm.vue?vue&type=template&id=6cd0ba88"
import script from "./SuggestedStudentForm.vue?vue&type=script&lang=js"
export * from "./SuggestedStudentForm.vue?vue&type=script&lang=js"
import style0 from "./SuggestedStudentForm.vue?vue&type=style&index=0&id=6cd0ba88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports